import { useState,useEffect } from 'react';
import {Button} from "./polaris/button"
import {Popup} from "./polaris/popup"
import {Skeleton} from "./polaris/skeleton"

function Lending() {
	const fixedPosition = { lat: 10.8276478, lng: 106.7188958 };
    const [userPosition, setUserPosition] = useState(null);
    const [distance,setDistance] = useState(null)
    // 10.862935,106.7208233
    // 10.8276478,106.7188958
    const [iphone, setIphone] = useState("iPhone 16 promax");
    const [loan, setLoan] = useState(6000000);
    const [sex, setSex] = useState("female");
    const [time,setTime] = useState(3)
    const [rate,setRate] = useState(0.08)
    const [step,setStep] = useState(1)

    const [popup,setPopup] = useState(false)
    const [success,setSuccess] = useState(null)
    
    const [job,setJob] = useState(null)
    const [phone,setPhone] = useState(null)
    const [facebook,setFacebook] = useState(null)
    const [purpose,setPurpose] = useState(null)

    const loanLimits = {
        "iPhone 16 promax": 15000000,
        "iPhone 15 promax": 12000000,
        "iPhone 14 promax": 10000000,
        "iPhone 13 promax": 8000000,
        "iPhone 12 promax": 5000000
    };
    const getMaxLoan = () => {
        let baseMax = loanLimits[iphone] || 6000000;
        return sex === "female" ? baseMax + 0 : baseMax;
    };

    const toRadians = (degree) => degree * (Math.PI / 180);

    // Hàm tính khoảng cách Haversine (theo km)
    const calculateDistance = (pos1, pos2) => {
        if (pos1 === null || pos2 === null) return null;
        const R = 6371; // Bán kính trái đất trong km
        const dLat = toRadians(pos2.lat - pos1.lat);
        const dLng = toRadians(pos2.lng - pos1.lng);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(toRadians(pos1.lat)) * Math.cos(toRadians(pos2.lat)) *
                Math.sin(dLng / 2) * Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c; // khoảng cách trong km
        return distance;
    };

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
            const { latitude, longitude } = position.coords;
            const currentUserPosition = { lat: latitude, lng: longitude };
            setUserPosition(currentUserPosition);
            if (currentUserPosition) {
            const d = calculateDistance(fixedPosition, currentUserPosition);
            setDistance(d)
            }
        }, (error) => {
            console.error(error);
        });
        }

    }, []); // Chỉ chạy 1 lần khi component mount

    useEffect(() => {
        setLoan(getMaxLoan());
    },[sex,iphone,job]);

    

    const Step = () => {
        return <>
        <div className="w-full max-w-lg mx-auto my-6 px-2 text-white">
            <div className="flex justify-between mb-8">
                <div className="flex items-center">
                <div style={{
                        borderTop: "1px solid #646464",
                        borderLeft: "1px solid #646464",
                        borderRight: "1px solid #646464",
                        borderBottom: "1px solid #0a0a0a"
                }} className="w-6 h-6 lg:w-10 lg:h-10 flex items-center justify-center bg-[#343434] text-white rounded-full">
                    1
                </div>
                <div className="ml-4 text-sm lg:text-lg font-semibold">Nhận hồ sơ</div>
                </div>
                <div className="flex items-center">
                { step === 1 ? <div className="w-6 h-6 lg:w-10 lg:h-10 flex items-center justify-center bg-gray-300 text-gray-700 rounded-full">
                    2
                </div> : <div style={{
                        borderTop: "1px solid #646464",
                        borderLeft: "1px solid #646464",
                        borderRight: "1px solid #646464",
                        borderBottom: "1px solid #0a0a0a"
                }} className="w-6 h-6 lg:w-10 lg:h-10 flex items-center justify-center bg-[#343434] text-white rounded-full">
                    2
                </div> }
                
                <div className="ml-4 text-sm lg:text-lg font-semibold">Thẩm định</div>
                </div>
                <div className="flex items-center">
                <div className="w-6 h-6 lg:w-10 lg:h-10 flex items-center justify-center bg-gray-300 text-gray-700 rounded-full">
                    3
                </div>
                <div className="ml-4 text-sm lg:text-lg font-semibold">Giải ngân</div>
                </div>
            </div>

            <div className="flex justify-between">
                <div className="h-1 flex-1 bg-[#343434]"></div>
                { step === 1 ? <div className="h-1 flex-1 bg-gray-300"></div> : <div className="h-1 flex-1 bg-[#343434]"></div> }
                <div className="h-1 flex-1 bg-gray-300"></div>
            </div>
            </div>

            </>
    }

    const sendMessageToTelegram = () => {
        if(!phone || !facebook || !purpose || !job) {setPopup(true); return}

        const TELEGRAM_CHAT_ID = "-916951689";  // ID của chat
        const TELEGRAM_BOT_TOKEN = "6242855353:AAHUZ7W9qWCJY1wGpcWrKbYz8p0wvE2y5wI";  // Token bot của bạn
        const url = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`;
        const message = `vị trí: ${distance},thiết bị: ${iphone}, giới tính: ${sex}, số tiền cần vay: ${loan},số điện thoại: ${phone},facebook: ${facebook},mục đích vay vốn: ${purpose},nghề nghiệp: ${job},hình thức vay: ${rate}`
        const payload = {
            chat_id: TELEGRAM_CHAT_ID,
            text: message,
        };
        setSuccess('loading')
        fetch(url, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
        .then(response => response.json())
        .then(data => {
          console.log("Message sent to Telegram:", data);
          setStep(2);setSuccess(true);setPopup(true);
        })
        .catch(error => {
          console.error("Error sending message to Telegram:", error);
        });
    };
    
    return (
    <div className="min-h-screen flex">
        <div className='self-center mx-auto'>
            { success !== 'loading' ? <>
            <section className="max-w-[1170px] mx-auto px-2 lg:px-0 my-6">
                <Step/>
            </section>

            {/* {  distance && distance > 40 ? <>
                <section className="max-w-[1170px] mx-auto px-2 lg:px-0 my-6">
                    <div class="bg-[#f1f2f1] border border-[#f1f2f1] text-sm rounded-lg p-4" role="alert" tabindex="-1" aria-labelledby="hs-soft-color-warning-label">
                        <div className="flex gap-2 my-2">
                            <svg class="shrink-0 size-4 mt-0.5 self-center" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
                                <path d="M12 9v4"></path>
                                <path d="M12 17h.01"></path>
                            </svg>
                        <span className="self-center">Với các khoản vay ở xa/ ở tỉnh, có thể chúng tôi sẽ thu thêm công tác phí 150k</span> 
                        </div>
                    </div>
                </section>
                </> : null } */}

            <section className="max-w-[1170px] mx-auto px-2 lg:px-0 my-10 space-y-5">
                <div className="bg-[#f1f2f1ab] p-4 lg:p-10 gap-10 rounded-2xl grid grid-cols-1 lg:grid-cols-2">
                    <div className="left flex flex-col gap-2 space-y-6">
                        <div className="grid grid-cols-2">
                            <div className=''>
                                <p className="text-md font-semibold">Thiết bị sử dụng</p>
                                {/* <p className="text-sm">{navigator.userAgent}</p> */}
                            </div>
                            <div className=''>
                                <select className="w-full px-2 rounded py-1" value={iphone} onChange={(e) => setIphone(e.target.value)}>
                                    {Object.keys(loanLimits).map((model) => (
                                        <option key={model}>{model}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="grid grid-cols-2">
                            <p className="text-md font-semibold">Giới tính</p>
                            <select className="w-full px-2 rounded py-1" value={sex} onChange={(e) => setSex(e.target.value)}>
                                <option value="male">Nam</option>
                                <option value="female">Nữ</option>
                            </select>
                        </div>

                        <div className="grid grid-cols-2">
                            <p className="text-md font-semibold">Số tiền cần vay</p>
                            <input 
                                type="range" 
                                min="1000000" 
                                max={getMaxLoan()} 
                                step="1000000" 
                                className="w-full range range-sm" 
                                value={loan} 
                                onChange={(e) => setLoan(Number(e.target.value))} 
                            />
							<div></div>
							<div className="grid grid-cols-2">
								<p className="text-sm font-semibold text-center">1.000.000 VNĐ</p>
                            	<p className="text-sm font-semibold text-center">{getMaxLoan().toLocaleString()} VNĐ</p>
							</div>
                        </div>

                        <div className="grid grid-cols-2">
                            <p className="text-md font-semibold">Thời hạn thanh toán</p>
							<div>
								<select className="w-full px-2 rounded py-1" value={time} onChange={(e) => setTime(Number(e.target.value))} >
                                    {/* { sex === 'male' ?
                                    <>
                                    <option value="1">1 tháng</option>
                                    </> : <>
                                    <option value="3">3 tháng</option>
									<option value="6">6 tháng</option>
									<option value="9">9 tháng</option>
                                    <option value="12">12 tháng</option>
                                    </>
                                    } */}
                                    <option value="3">3 tháng</option>
									<option value="6">6 tháng</option>
									<option value="9">9 tháng</option>
                                    <option value="12">12 tháng</option>
								</select>
							</div>
                        </div>

                        <div className="grid grid-cols-2">
                            <p className="text-md font-semibold rounded py-1">Số điện thoại</p>
                            <input type="number" className="w-full rounded" onChange={(e) => setPhone(e.target.value)}/>
                        </div>

                        <div className="grid grid-cols-2">
                            <p className="text-md font-semibold rounded py-1">Facebook</p>
                            <input type="text" className="w-full rounded" onChange={(e) => setFacebook(e.target.value)}/>
                        </div>

                        <div className="grid grid-cols-2">
                            <p className="text-md font-semibold rounded py-1">Mục đích vay vốn</p>
                            <input type="text" className="w-full rounded" onChange={(e) => setPurpose(e.target.value)}/>
                        </div>

                        <div className="grid grid-cols-2">
                            <p className="text-md font-semibold rounded py-1">Nghề nghiệp</p>
                            <input type="text" className="w-full rounded" onChange={(e) => setJob(e.target.value)}/>
                        </div>

                        <div className="grid grid-cols-2">
                            <p className="text-md font-semibold rounded py-1">Hình thức vay</p>
                            <select className="w-full px-2 rounded py-1" onChange={
                                (e) => {
                                    if(e.target.value == 'tin_chap'){
                                        setRate(0.08)
                                    }
                                    else{
                                        setRate(0.06)
                                    }
                                }}>
                                <option value="tin_chap">Tín chấp qua icloud</option>
                                <option value="the_chap">Thế chấp tài sản</option>
                            </select>
                        </div>

                    </div>
                    <div className="right flex flex-col items-center justify-center gap-4 bg-white p-10 rounded-2xl">
                        <div className="flex-grow flex flex-col items-center justify-center gap-2 p-2 lg:p-1 w-full">
                            <p>Khoản vay có thể được duyệt (VNĐ)</p>
                            <h1 style={{
                                background: 'linear-gradient(to right, #f32170,#ff6b08, #cf23cf, #eedd44)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent'
                            }} className="text-2xl lg:text-6xl font-bold">{loan.toLocaleString()}</h1>

                            <p>Phương án trả trong {time} tháng</p>
                            <div className='text-left w-full'>
                            {[...Array(time)].map((_, index) => {
                                // Tính số tiền thanh toán hàng tháng (A) theo công thức Annuity
                                const monthlyPayment = (loan * rate) / (1 - Math.pow(1 + rate, -time));

                                // Tính số dư nợ còn lại trong mỗi tháng (cần tính lại số dư nợ sau mỗi tháng)
                                const remainingLoan = loan * Math.pow(1 + rate, index) - monthlyPayment * ((Math.pow(1 + rate, index) - 1) / rate);

                                // Tính phần lãi trong kỳ (lãi = số dư nợ còn lại * lãi suất hàng tháng)
                                const interestPayment = remainingLoan * rate;

                                // Tính phần gốc trong kỳ (gốc = khoản thanh toán - lãi trong kỳ)
                                const principalPayment = monthlyPayment - interestPayment;

                                return (
                                <div className='my-2 border-2 rounded bg-[#f1f2f1]'>
                                    <div key={index} className='flex gap-2 my-0 px-2 py-1'>
                                        <span className="text-xl font-bold mr-auto self-center">Tháng {index + 1} trả :</span>
                                        <span className='ml-auto text-end self-center'>{monthlyPayment.toLocaleString()} đ</span>
                                    </div>
                                    <div key={index} className='flex gap-2 my-0 px-2 py-1'>
                                        <span className='text-sm mr-auto text-start self-center'>Lãi: {interestPayment.toLocaleString()} đ</span>
                                        <span className='text-sm ml-auto text-end self-center'>Gốc: {principalPayment.toLocaleString()} đ</span>
                                    </div>
                                </div>
                                );
                            })}
                            </div>
                            
                            {/* <button className="btn bg-[#049246] px-5 py-2 font-bold text-white rounded border-none">Thẩm định</button> */}
                        </div>
                        <p className="text-xs grid grid-cols-1">
                            * Thông tin và kết quả chỉ mang tính tham khảo. Khoản vay được xét duyệt sẽ tùy thuộc vào điều kiện và hồ sơ cụ thể của từng trường hợp.
                            
                            <span className='text-[#049246] w-full my-1'>
                                Lưu ý các khoản phí sau có thể phát sinh nếu bạn có nhu cầu dịch vụ
                            </span>
                            <ul className='text-[#049246] w-full my-1'>
                                <li>- Phí đổi tên icloud theo ý bạn cần 90k</li>
                                <li>- Phí hỗ trợ tải phần mềm, vì khi cài icloud chúng tôi sẽ ko để lộ mật khẩu để bảo đảm an toàn, do đó khi bạn cần cài phần mềm, buộc nhân viên sẽ phải hỗ trợ tận nơi, tốt nhất bạn nên cài mọi phần mềm bạn cần vào máy trước (200k)</li>
                                <li>- Phí hỗ trợ gấp, làm khuya, vào cuối tuần hoặc ngày nghỉ (200k)</li>
                                <li>- Thanh toán trước hạn, vì thanh toán trước hạn chúng tôi sẽ phải cân đối lại số dư trước thời hạn, gây tốn kém nên cần thu phụ phí, nhưng điều này sẽ có lợi cho bạn, vì bạn sẽ đỡ phải trả lãi thêm (120k)</li>
                            </ul>    
                            
                        </p>
                        <div className="w-full">
                            <Button click={() => {
                                sendMessageToTelegram();
                            }}>Thẩm định</Button>
                        </div>
                    </div>
                </div>
            </section>
            </> : 
            <>
            <section className="max-w-[1170px] mx-auto px-2 lg:px-0 my-10 space-y-5">
                <div className="bg-[#f1f2f1] p-4 lg:p-16 gap-10 rounded-2xl grid grid-cols-3">
                    <div></div>
                    <Skeleton/>
                    <div></div>
                </div>
            </section>
            </>
             }
        </div>

        {success === true && step === 2 && popup === true ?
        <Popup status={popup}>
            <div className="bg-white p-4 rounded-lg max-w-[800px] mx-auto">
                <div className='font-semibold text-center'>
                    Chúng tôi đã nhận đủ thông tin
                </div>
                <p className="text-sm text-center mb-3">Và sẽ liên hệ lại bạn trong thời gian sớm nhất</p>
                <Button click={() => {setPopup(false);window.location.reload();}}>Tắt</Button>
            </div>
        </Popup> : step === 1 && popup === true ? 
        <Popup status={popup}>
            <div className="bg-white p-4 rounded-lg max-w-[800px] mx-auto">
                <div className='font-semibold text-center'>
                    Vui lòng điền đủ thông tin
                </div>
                <p className="text-sm text-center mb-3">Để tôi có thể thẩm định dễ dàng và liên hệ lại bạn trong thời gian sớm nhất</p>
                <Button click={() => setPopup(false)}>Tắt</Button>
            </div>
        </Popup> : null }

    </div>

    );
}

export default Lending;
